<template>
  <v-dialog v-model="dialog" max-width="800px">
    <v-card>
      <v-card-title>文件预览</v-card-title>
      <v-card-text>
        <div v-if="loading">加载中...</div>
        <div v-else-if="error">{{ error }}</div>
        <iframe v-if="url" :src="url" width="100%" height="600px"></iframe>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey darken-1" text @click="close">关闭</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { commonApi } from '@/api/common'

export default {
  name: 'PreviewMaterialPopup',

  data() {
    return {
      dialog: false,
      loading: false,
      url: '',
      error: ''
    }
  },

  methods: {
    open(fileId) {
      this.dialog = true;
      this.fetchFileLink(fileId);
    },

    close() {
      this.dialog = false;
      this.url = '';
      this.error = '';
    },

    async fetchFileLink(fileId) {
      this.loading = true;
      try {
        const response = await commonApi.getFileLink(fileId);
        this.url = response.data.url; // 获取文件链接
      } catch (error) {
        this.error = error.response?.data?.message || error.message || '获取文件链接失败';
      } finally {
        this.loading = false;
      }
    }
  }
}
</script> 